export default {
  removeEmpty (data) {
    Object.keys(data).forEach(key => {
      if (data[key] && typeof data[key] === 'object') this.removeEmpty(data[key]) // recurse
      else if (data[key] == null || data[key] === undefined || data[key].length === 0) delete data[key] // delete
    })
    return data
  }
}
